import React, { useContext, Fragment } from 'react';
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';

const BotonesCuenta = () => {

    // Extraer funciones del context
    const barrapplContext = useContext(barraprincipalContext);
    const { vistamenu, verCuentas } = barrapplContext;

    const cambiarVista = (boton1, boton2, status) => {
        const btn1 = document.getElementById(boton1);
        const btn2 = document.getElementById(boton2);
        
        btn1.classList.add('active');
        btn2.classList.remove('active');
        verCuentas(status);
    }

    return ( 
        <div className="formulario">
            <div className="contenedor-btns">
                {vistamenu === 'crearcuenta' ? (
                    <Fragment>
                        <div className="btns">
                            <button
                                id="btn-crear-cuenta"
                                className="active"
                                onClick={(e) => cambiarVista(e.target.id, 'btn-ver-cuentas', false)}
                            >Crear Cuenta</button>
                        </div>
                        <div className="btns">
                            <button
                                id="btn-ver-cuentas"
                                onClick={(e) => cambiarVista(e.target.id, 'btn-crear-cuenta', true)}
                            >Cuentas</button>
                        </div>
                    </Fragment>
                ) : (
                    <div className="btns">
                        <button
                            className="active"
                        >Perfil</button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BotonesCuenta;